import style from './SuperChargeWithAgent.module.css';
import React, { useState, useRef, FormEvent, useEffect } from 'react';
import { NewRequestDemoForm } from '@/components/NewRequestDemoForm/NewRequestDemoForm';
import { clsx } from 'clsx';
import { GreenCircleArrows } from '@/assets/icons/greenCircleArrows';
import styled from 'styled-components';
import { Container } from '@/components/Containers/Container';
import { PATH_SUCCESS } from '@/constants/spa-routes';
import { useRouter } from 'next/router';

type SuperChargeWithAgentProps = {
  isMobile: boolean;
};

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const StyledImage = styled.img({
  filter: 'drop-shadow(-5px 10px 15px #000000)',
});

export const SuperChargeWithAgent = ({ isMobile }: SuperChargeWithAgentProps) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef<React.RefObject<HTMLDivElement> | undefined>();
  const { push } = useRouter();
  const onButtonClick = async (event: FormEvent) => {
    if (!isExpanded) {
      event.preventDefault();
      setIsExpanded(true);
      //@ts-ignore
      containerRef.current.style.height =
        //@ts-ignore
        containerRef.current.firstChild.clientHeight + 'px';

      await wait(1500);
      //@ts-ignore
      containerRef.current.style.overflow = 'visible';
    }
  };

  const onFormSubmit = async (response: any) => {
    if (response.success) {
      setIsSuccess(true);
      //@ts-ignore
      window.scrollTo(0, containerRef.current.offsetParent.offsetTop);
      await wait(300);
      setIsExpanded(false);
      //@ts-ignore
      containerRef.current.style.overflow = 'hidden';
      //@ts-ignore
      containerRef.current.style.height = 0;

      const name = response.data?.name;
      const email = response.data?.email;
      const url = `${PATH_SUCCESS.ROOT}?name=${encodeURI(name || '')}&email=${encodeURI(email || '')}`;

      await push(url);
    }
  };

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.5;
    }
  }, [videoRef]);

  return (
    <section className="relative bg-gradient_fresh_mobile">
      <video
        className="absolute min-h-full bg-black w-full object-cover z-0 top-0 left-0 opacity-40"
        ref={videoRef}
        autoPlay
        muted
        playsInline
        loop
        disablePictureInPicture
        poster="/img/Video_2.0_frame.webp"
      >
        <source src={'/video/Video_cosupport_2.0.mp4'} type="video/mp4" />
      </video>
      <Container className="md:pt-24.5-vw pt-15">
        <div
          className={`${isMobile ? style.containerMobile : style.containerDesktop} ${isExpanded ? style.expanded : ''}`}
        >
          <div className={clsx(style.title, 'z-10')}>
            <h2>Get started with CoSupport AI & Freshdesk</h2>
            {
              <p className={`${style.successMessage} ${isSuccess ? style.visible : ''}`}>
                <span className={'green'}>Great, you're set!</span>
                <br />
                Thanks for opting to explore our demo – look out for our follow-up. Please check
                your email! <span className={'green'}>→</span>
              </p>
            }
          </div>
          <div
            //@ts-ignore
            ref={containerRef}
            style={{ height: 0 }}
            className={`${style.formContainer} ${isSuccess ? style.hidden : ''}`}
          >
            <div>
              <div className={style.formText}>
                {isMobile ? (
                  <p>
                    For a tailored experience, please fill out this form. It'll help us customize
                    your demo preview.
                  </p>
                ) : (
                  <p>
                    For a tailored experience, please fill out this form.
                    <br /> It'll help us customize your demo preview.
                  </p>
                )}
              </div>
              <NewRequestDemoForm
                tags={['Freshdesk Page Form - Demo']}
                id="requestDemoFormSuperCharge"
                name={'required'}
                email={{
                  required: true,
                  validationPopupPosition: isMobile ? 'bottom' : 'right',
                }}
                phone
                tickets={{ required: true }}
                message
                messageResizable={false}
                darkMode={true}
                onSubmit={onFormSubmit}
                showSpinner={true}
              />
            </div>
          </div>
          {!isSuccess && (
            <button
              onClick={onButtonClick}
              className={style.button}
              form={'requestDemoFormSuperCharge'}
            >
              <span className={style.gradient}></span>
              Request Demo Now
            </button>
          )}
          <div className="flex flex-col gap-5.5 md:gap-5-vw z-10 mt-15">
            <div className="flex items-center justify-center md:gap-7 gap-6 relative">
              <div className="relative">
                <picture
                  className={clsx('lg:max-h-[32.972vw] lg:h-[32.972vw] object-fill object-center')}
                >
                  <source
                    srcSet="/img/freshdesk-integration/freshdesk-super-charge.webp"
                    media="(min-width: 1024px)"
                  />
                  <StyledImage
                    className="h-full w-full lg:max-h-[32.972vw] lg:h-[32.972vw] object-fill object-center"
                    src="/img/freshdesk-integration/freshdesk-super-charge-mobile.webp"
                    alt={`freshdesk image`}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
